export default class UtilsDom {

    constructor() {
    }


    removeClass(domElement:any, className:string) {
        if (domElement) domElement.classList.remove(className);
    }

    removeAllClasses(domElement:any) {
        if (domElement) domElement.removeAttribute("class");
    }

    addClass(domElement:any, className:string) {
        if (domElement) domElement.classList.add(className);
    }

    addClasses(domElement:any, class1:string, class2?:string, class3?:string, class4?:string) {
        if (!domElement) return;

        domElement.classList.add(class1);
        if (class2) domElement.classList.add(class2);
        if (class3) domElement.classList.add(class3);
        if (class4) domElement.classList.add(class4);
    }

    toggleClass(domElement:any, className:string, value:boolean) {
        value ? this.addClass(domElement, className) : this.removeClass(domElement, className)
    }

    addId(domElement:any, id:string) {
        if (domElement) domElement.setAttribute("id", id);
    }

    getCoordinatesDelta(a:any, b:any) {
        return {
            dx: a.x - b.x,
            dy: a.y - b.y
        };
    }

    findNodeByClassName(node:any, className:string|any) {
        let parentNode = null;

        // prepare check function depending on searchObject passed
        let checkFunc;
        if (typeof className === 'string')  checkFunc = (classList:string[]) => _.includes(classList, className);  // string
        else                                checkFunc = (classList:string[]) => _.intersection(classList, className).length > 0;  // array

        // search if
        // - node still available
        // - parent node is not found
        while(node && !parentNode) {
            if (node && checkFunc(node.classList)) parentNode = node;
            else node = node.parentNode;
        }
        return parentNode
    }

    checkNodeHasFunction(node:any, searchObject:any, thresholdNode = null) {
        let res = false;

        // if thresholdNode is not set then current node parent node is thresholdNode
        // it means that we search for function only in passed node object and stop
        if (!thresholdNode) thresholdNode = node.parentNode;

        // prepare check function depending on searchObject passed
        let checkFunc;
        if (typeof searchObject === 'string')   checkFunc = (n:any) => !!n[searchObject]; // string
        else if (Array.isArray(searchObject))   checkFunc = (n:any) => _.some(searchObject, funcName=>!!n[funcName]); // array
        else console.warn("UtilsDom checkNodeHasFunction: searchObject is not supported ({0})".f(searchObject));

        // search if
        // - node still available
        // - searched node is not found
        // - thresholdNode is not reached
        while(node && !res && node !== thresholdNode) {
            if (node && checkFunc && checkFunc(node)) res = true;
            else node = node.parentNode;
        }
        return res
    }

    checkMouseOverNode(mouseEvent:any, node:any) {
        const rect = node.getBoundingClientRect();
        const mousePos = {x: mouseEvent.clientX, y: mouseEvent.clientY};

        return  (mousePos.x > rect.x && mousePos.x < (rect.x + rect.width)) &&
                (mousePos.y > rect.y && mousePos.y < (rect.y + rect.height))
    }

    checkMouseOverRectArea(mouseEvent:any, rect:any, xDivisions = 2, yDivisions = 2) {
        const mousePos = {x: mouseEvent.clientX, y: mouseEvent.clientY};
        const { left, right, top, bottom } = rect;
        const dx = (right - left)/xDivisions;
        const dy = (top - bottom)/yDivisions;

        if (mousePos.y < top || mousePos.y > bottom || mousePos.x < left || mousePos.x > right) {
            /* mouse pointer is outside rect */
            return false;
        } else {
            const xLine = _.min([Math.floor((mousePos.x - left)/dx), xDivisions-1]); // may become xDivisions value eventually but only xDivisions - 1 is legal value
            const yLine = _.min([Math.floor((top - mousePos.y)/dy), yDivisions-1]); // may become yDivisions value eventually but only yDivisions - 1 is legal value

            /*
            * yLine\xLine 0   1
            *           ---------
            *       0   | - | - |
            *           ---------
            *       1   | - | - |
            *           ---------
            *
            *   Default 4 areas for mouse coordinates to be in;
            *   For default divisions yLine = 0 means top half of rect and yLine = 1 - bottom half,
            *   xLine = 0 - left half of rect, xLine = 1 = right half
            */

            return {xLine,yLine}
        }
    }

    isInViewport(el:any) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
